export default __webpack_public_path__ + "static/media/Corporate_4.806b6a7b.png";